import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { getImageURL } from 'utils/resizer'
import { getEmojiURL } from 'utils/emoji'
import { withStyles } from '@material-ui/core/styles'
import MuiAvatar from '@material-ui/core/Avatar'

const sizes = {
  small: 48,
  default: 80,
  large: 120,
}

const styles = theme => ({
  root: {
    lineHeight: 0,
    textTransform: 'uppercase',
    backgroundColor: theme.palette.grey[200],
  },
  small: {
    width: sizes.small,
    height: sizes.small,
  },
  default: {
    width: sizes.default,
    height: sizes.default
  },
  large: {
    width: sizes.large,
    height: sizes.large
  },
  emoji: {
    width: 24,
    height: 24,
  }
})

const firstLetter = str => ((str && str[0]) || '')

const getAvatarProps = ({ firstName, lastName, image, avatar, size, classes }) => {
  if (image) {
    return {
      src: getImageURL(image, sizes[size])
    }
  }

  if (avatar) {
    return {
      src: getEmojiURL(avatar.emoji.unified),
      imgProps: { className: classes.emoji },
      style: { backgroundColor: avatar.color }
    }
  }

  return {
    children: (
      <Fragment>
        { firstLetter(firstName) }
        { firstLetter(lastName) }
      </Fragment>
    )
  }
}

const Avatar = (props) => {
  const { classes, className, size, image, avatar, firstName, lastName, ...rest } = props
  return (
    <MuiAvatar
      {...rest}
      {...getAvatarProps(props)}
      className={classNames(className, classes.root, classes[size])}
    />
  )
}

Avatar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
  image: PropTypes.any,
  avatar: PropTypes.object,
  firstName: PropTypes.any,
  lastName: PropTypes.any,
  size: PropTypes.oneOf(['large', 'default', 'small']),
}

Avatar.defaultProps = {
  size: 'default'
}

export default withStyles(styles)(Avatar)
